import { AdditionalInfo, BoxButton, StickyBottomWrapper } from '@repo/ui';

import { BznavRefundGoodPoint } from './BznavRefundGoodPoint';
import { GuidelinesAndPrecautions } from './GuidelinesAndPrecautions';
import { PartnerDiscountBanner } from './PartnerDiscountBanner';
import { UserRefundAmount } from './UserRefundAmount';
import { VipCounsel } from './VipCounsel';

import { BusinessType } from '@/lib/types/request';
import numberWithCommas from '@/lib/utils/numberWithCommas.ts';

export const ApplyPossiblePresentationalContent = ({
  userName,
  businessType,
  incomeRefundAmount,
  tritxRefundAmount,
  partnerDiscountInformation,
  isTritxTaxIncluded,
  isVIP,
  isSubmitted,
  onClickCta
}: {
  userName: string;
  businessType: BusinessType;
  incomeRefundAmount: number;
  tritxRefundAmount: number;
  isVIP: boolean;
  partnerDiscountInformation?: {
    defaultFeeRate: string;
    endAt: string;
    feeRate: string;
    partnerName: string;
    startAt: string;
  } | null;
  isSubmitted?: boolean;
  isTritxTaxIncluded: boolean;
  onClickCta: () => void;
}) => {
  const infoText = incomeRefundAmount > 0 && tritxRefundAmount > 0 && isTritxTaxIncluded ? '종합소득세와 양도소득세를 함께 환급받을게요' : '';
  return (
    <>
      <div className="w-full flex-1">
        <div>
          <article className={'bg-white w-full'}>
            <UserRefundAmount businessType={businessType} userName={userName} refundAmount={incomeRefundAmount} tritxRefundAmount={tritxRefundAmount} />
            {isVIP && <VipCounsel />}
            <BznavRefundGoodPoint />
            <div className={'mb-normal-large'}>
              <GuidelinesAndPrecautions />
              {partnerDiscountInformation && <PartnerDiscountBanner {...partnerDiscountInformation} />}
            </div>
            <AdditionalInfo
              className={'w-full flex-col !p-0'}
              divider={false}
              info={infoText && <p className={'caption-medium-regular text-neutral-foreground-low'}>{infoText}</p>}
            />
          </article>
        </div>
      </div>
      <StickyBottomWrapper className={'sticky w-full bg-white'}>
        <BoxButton variant="filled-primary" size="large" className="w-full" onClick={onClickCta} isLoading={isSubmitted}>
          {numberWithCommas(Number(incomeRefundAmount) + Number(isTritxTaxIncluded ? tritxRefundAmount : 0))}원 환급 신청
        </BoxButton>
      </StickyBottomWrapper>
    </>
  );
};
